import { useEffect, useState } from 'react';
import Icon from './Icon';
import { useLanguage } from '../i18n/language';
import { useT } from '../i18n/translations';
import { fetchSuperAdminSubscriptions } from '../superAdminSubscriptionsApi';
import './BranchesPage.css';
import './UsersPage.css';

export default function SuperAdminSubscriptionsPage() {
  const { language, direction } = useLanguage();
  const t = useT();
  const dateLocale = (language === 'ar' || language === 'ur') ? 'ar-SA' : 'en-US';

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const data = await fetchSuperAdminSubscriptions();
        if (!cancelled) setRows(data);
      } catch (e) {
        if (!cancelled) setError(e instanceof Error ? e.message : t('superAdmin.loadFailed'));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="page users-page" dir={direction}>
      <div className="list-page-card list-page-card--unified">
        <header className="list-page-card__header">
          <div className="list-page-card__titles">
            <span className="list-page-card__title"><Icon name="money" size={18} color="#00334a" style={{ verticalAlign: 'middle', marginLeft: 6 }} />{t('superAdmin.subscriptions')}</span>
            <span className="list-page-card__sub">{t('superAdmin.subscriptionsSub')}</span>
          </div>
        </header>

        {error && <div className="list-page-card__banner list-page-card__banner--error">{error}</div>}
        {loading && <div className="list-page-card__loading">{t('superAdmin.loading')}</div>}

        {!loading && (
        <div className="table-card">
          <table className="data-table">
            <thead>
              <tr>
                <th style={{ width: 42 }}>#</th>
                <th>{t('common.company')}</th>
                <th>{t('superAdmin.packages')}</th>
                <th>{t('superAdmin.ceos')}</th>
                <th>{t('superAdmin.colTrial')}</th>
                <th>{t('superAdmin.colCompanyStatus')}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr key={`${row.companyId}-${row.ceoUserName}`}>
                  <td className="td-num">{idx + 1}</td>
                  <td>
                    <strong>{row.companyName}</strong>
                    <div className="users-email">{row.companyEmail || '-'}{row.companyPhone ? ` · ${row.companyPhone}` : ''}</div>
                  </td>
                  <td>
                    <strong>{row.packageName}</strong>
                    <div className="users-email">{row.packageLabel || '-'}</div>
                  </td>
                  <td>
                    <strong>{row.ceoFullName || row.ceoUserName}</strong>
                    <div className="users-email">{row.ceoEmail || '-'}{row.ceoPhone ? ` · ${row.ceoPhone}` : ''}</div>
                  </td>
                  <td>
                    <span className={`users-status users-status--${row.isTrialSubscription ? 'pending' : 'active'}`}>
                      {row.isTrialSubscription ? t('superAdmin.trial') : t('superAdmin.regular')}
                    </span>
                    {row.trialEndsAtUtc && (
                      <div className="users-email">{t('superAdmin.endsAt')}: {new Date(row.trialEndsAtUtc).toLocaleString(dateLocale)}</div>
                    )}
                  </td>
                  <td>
                    <span className={`users-status users-status--${row.isCompanyActive ? 'active' : 'inactive'}`}>
                      {row.isCompanyActive ? t('common.active') : t('common.inactive')}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {rows.length === 0 && <div className="users-empty">{t('superAdmin.noSubscriptions')}</div>}
        </div>
      )}
      </div>
    </div>
  );
}
